import { t } from "@/i18n-js/instance";

import { useHasCommunityCodeSnippets } from "../hooks/useHasCommunityCodeSnippets";

export const usePreviewBarContent = () => {
  const hasCodeSnippets = useHasCommunityCodeSnippets();

  return {
    hasCodeSnippets,
    previewBarCtaContent: t("new_version_preview_bar.preview_bar_cta_content"),
    previewBarText: hasCodeSnippets
      ? t("new_version_preview_bar.preview_bar_text_with_code_snippets")
      : t("new_version_preview_bar.preview_bar_text"),
  };
};
